<template>
    <form-modal
        :name="'first-rating-' + ratingType"
        primary-button-text="Godkänn och betygsätt"
        primary-button-class="is-primary"
        cancel-button-text="Nej, tack"
        icon-title="Hur ser din kost ut?"
        :icon="['fal', 'tachometer-alt-average']"
        :action="action"
        :callback="callback"
    >
        <p class="text-xs text-center mb-0">
            För att få roligare statistik skulle vi vilja veta vad du brukar äta.
        </p>
        <div class="flex flex-col items-center my-2xl">
            <radio-input
                v-for="(dietLabel, dietKey) in dietLabels"
                :key="dietKey"
                v-model="diet"
                name="diet"
                :value="dietKey"
                class="mb-md"
            >
                {{ dietLabel }}
            </radio-input>
        </div>
        <p class="text-xs text-center mb-0">
            Du behöver godkänna att vi får spara din IP-adress samt lagra en liten bit
            data på din enhet för att vi ska kunna registrera dina betyg. Detta behöver vi
            göra för att förhindra missbruk av betygsättningsfunktionen.
        </p>

        <input
            type="hidden"
            name="rating_type"
            :value="ratingType"
        >
        <input
            type="hidden"
            name="score"
            :value="score"
        >
    </form-modal>
</template>

<script>
    export default {
        props: {
            action: {
                type: String,
                required: true,
            },
            callback: {
                type: Function,
                required: true,
            },
            ratingType: {
                type: String,
                required: true,
            },
            score: {
                type: Number,
                default: null,
            },
            userDiet: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                diet: this.userDiet,
                dietLabels: window.App.dietLabels,
            };
        },
    };
</script>
